
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M239.187 6.973L87.024 159.335c-9.282 9.296-9.282 24.372 0 33.668 9.285 9.298 24.34 9.298 33.624 0L232.224 81.282v406.911C232.226 501.34 242.871 512 256 512s23.776-10.66 23.776-23.808V81.282L391.35 193c9.287 9.298 24.34 9.298 33.625 0 4.643-4.648 6.963-10.741 6.963-16.834s-2.32-12.186-6.963-16.834L272.813 6.973c-9.288-9.297-24.339-9.297-33.626 0z"}})])
          )
        }
      }
    